import React, { useState } from "react";
import RadioGroup from "../../atoms/RadioGroup";

const UserType = ({ selectedUserType, onCheckUserType }) => {
  const radioOptions = [
    { label: "Seller", value: "seller" },
    { label: "Buyer", value: "buyer" },
    { label: "Trader", value: "trader" },
  ];

  const initialState = radioOptions.reduce((acc, { value }) => {
    acc[value] = false;
    return acc;
  }, {});


  return (
    <div className="flex gap-8  mb-4">
      <RadioGroup
        options={radioOptions.map(({ label, value }) => ({
          label,
          value,
        }))}
        onChange={onCheckUserType}
        value={selectedUserType}
      />
    </div>
  );
};

export default UserType;
